<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<div class="sidebar-header">
    <img (click)="navigateHome()" class="logo" src="assets/images/logo_large.svg" alt="Argon Dashboard 2" loading="lazy">
</div>

<!-- User Profile Section -->
<div class="sidebar-user">
    <div class="avatar">A</div>
    <div class="user-info">
        <span class="user-role" [attr.title]="'Admin'">Admin</span>
        <span class="user-email" [attr.title]="userData?.email">{{userData?.email}}</span>
    </div>
</div>

<mat-nav-list appAccordion>
    <div class="menu-section">
        <mat-list-item appAccordionLink *ngFor="let menuitem of mainMenuItems; index as i" group="{{menuitem.state}}">
            <a (click)="activeRoute(i, $event)" [ngClass]="{ selected: readLocalStorageValue('activeIndex') == i }" appAccordionToggle [routerLink]="[menuitem.state]" *ngIf="menuitem.type !== 'nolink'">
                <span class="menu-icon-container">
                    <img class="menu-icon" [src]="readLocalStorageValue('activeIndex') == i ? menuitem.iconUrlActive : menuitem.iconUrl" alt="" loading="lazy">
                </span>
                <span class="menu-label">{{ menuitem.name }}</span>
            </a>
        </mat-list-item>
    </div>
</mat-nav-list>

<!-- Sidebar Footer (Sign Out) -->
<div class="sidebar-footer">
    <button class="signout-btn" (click)="logOut()">
        <img src="../../../../assets/images/logout.svg" alt="" class="signout-img" loading="lazy">
        Sign Out</button>
</div>